/** *******************************************************************************************************************
  Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.

  Licensed under the Apache License, Version 2.0 (the "License").
  You may not use this file except in compliance with the License.
  You may obtain a copy of the License at

      http://www.apache.org/licenses/LICENSE-2.0

  Unless required by applicable law or agreed to in writing, software
  distributed under the License is distributed on an "AS IS" BASIS,
  WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
  See the License for the specific language governing permissions and
  limitations under the License.
 ******************************************************************************************************************** */
import * as awsui from '@cloudscape-design/design-tokens';
import { css } from '@emotion/react';

const styles = {
  container: css({
    marginTop: awsui.spaceScaledL,
    marginBottom: awsui.spaceScaledXxxl,
  }),
  textEditorLayout: css({
    position: 'relative',
  }),
  input: css({
    display: 'inline-block',
    width: '100%',
  }),
  inputClear: css({
    position: 'absolute',
    float: 'right',
    top: '10px',
    right: '5px',
  }),
  inputClearSmall: css({
    position: 'absolute',
    float: 'right',
    top: '1px',
    right: '5px',
  }),
};

export default styles;
